import _ from "lodash";
import router from '@/router'

const state = {
  pregame: {},
  event: null,
  activeSport: 1,
  activeCategory: null,
  activeTournament: null,
  sports: {},
  config_loader: false,
  event_loader: false,
  fetch_loader: false,
}
const getters = {
  config_loader(state) {
    return state.config_loader
  },
  event_loader(state) {
    return state.event_loader
  },
  fetch_loader(state) {
    return state.fetch_loader
  },
  pregame(state) {
    return state.pregame
  },
  event(state) {
    return state.event
  },
  activeSport(state) {
    return state.activeSport
  },
  activeCategory(state) {
    return state.activeCategory
  },
  activeTournament(state) {
    return state.activeTournament
  },
  sports(state) {
    return state.sports
  },
}
const mutations = {
  SET_CONFIG_LOADER(state, payLoad){
    state.config_loader = payLoad;
  },
  SET_EVENT_LOADER(state, payLoad){
    state.event_loader = payLoad;
  },
  SET_FETCH_LOADER(state, payLoad){
    state.fetch_loader = payLoad;
  },
  SET_PREGAME(state, payLoad){
    state.pregame = payLoad;
  },
  SET_ACTIVE_SPORT(state, payLoad){
    state.activeSport = payLoad;
  },
  SET_ACTIVE_CATEGORY(state, payLoad){
    state.activeCategory = payLoad;
  },
  SET_ACTIVE_TOURNAMENT(state, payLoad){
    state.activeTournament = payLoad;
  },
  SET_SPORTS(state, payLoad){
    state.sports = payLoad;
  },
  SET_EVENT(state, payLoad){
    state.event = payLoad;
  },
}
const actions = {
  fetchFullData({ commit, dispatch, state}, payload){
    if(payload.first){ commit('SET_CONFIG_LOADER', true);}
    if(!payload.first){ commit('SET_FETCH_LOADER', true);}
    
    axios.get('/sportsbook/pregame',
    { params: { sport_id: state.activeSport, category_id: state.activeCategory, tournament_id: state.activeTournament } }).then((response) => {
      commit('SET_PREGAME', response.data.data);
      commit('SET_SPORTS', response.data.counter);
    })
    .catch((c) => {})
    .finally((f) => { 
      commit('SET_CONFIG_LOADER', false);
      commit('SET_FETCH_LOADER', false);
    })
  },
  fetchEvent({ commit, dispatch, state}, payLoad){
    commit('SET_EVENT_LOADER', true)
    commit('SET_EVENT', null)
    
    axios.get('/sportsbook/pregame/' + payLoad).then((response) => {
      commit('SET_EVENT', response.data)
      if(!payload.first){
        router.replace({ query: { s: state.activeSport , c: state.activeCategory, l : state.activeTournament, id: state.event.tournament_id }});
      }
      
    })
    .catch((c) => {
      commit('SET_EVENT', null);
    })
    .finally((f) => { 
      commit('SET_EVENT_LOADER', false)
    })
  },
  clearEvent()
  {
    commit('SET_EVENT', null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}